module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('Webheader.verifications')
    }
  }, [_c('template', {
    slot: "pageContent"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('verifications.lblSIREN'),
      "placeholderValue": _vm.$t('verifications.placeHSIREN'),
      "mandatoryErrorIndicator": _vm.sirenError,
      "regexpErrorIndicator": _vm.sirenRegexpError
    },
    model: {
      value: (_vm.siren),
      callback: function($$v) {
        _vm.siren = $$v
      },
      expression: "siren"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('verifications.lblSIRET'),
      "placeholderValue": _vm.$t('verifications.placeHSIRET'),
      "mandatoryErrorIndicator": _vm.siretError,
      "regexpErrorIndicator": _vm.siretRegexpError
    },
    model: {
      value: (_vm.siret),
      callback: function($$v) {
        _vm.siret = $$v
      },
      expression: "siret"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('verifications.lblVATNumber'),
      "placeholderValue": _vm.$t('verifications.placeHVATNumber'),
      "mandatoryErrorIndicator": _vm.vatNumberError,
      "regexpErrorIndicator": _vm.vatNumberRegexpError
    },
    model: {
      value: (_vm.vatNumber),
      callback: function($$v) {
        _vm.vatNumber = $$v
      },
      expression: "vatNumber"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "form-group",
    attrs: {
      "sm": "3"
    }
  }, [_c('form-write-group-label-input', {
    attrs: {
      "inputLabel": _vm.$t('verifications.lblSocialReason'),
      "placeholderValue": _vm.$t('verifications.placeHSocialReason'),
      "mandatoryErrorIndicator": _vm.socialReasonError,
      "regexpErrorIndicator": _vm.socialReasonRegexpError
    },
    model: {
      value: (_vm.socialReason),
      callback: function($$v) {
        _vm.socialReason = $$v
      },
      expression: "socialReason"
    }
  })], 1)], 1), _vm._v(" "), (_vm.entities.length > 1) ? _c('div', [_c('b-row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('b-col', {
    staticClass: "form-group",
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "font-italic"
  }, [_vm._v("\n            Veuillez sélectionner un des résultats ci-dessous\n          ")])])], 1), _vm._v(" "), _vm._l((_vm.entities), function(entity, index) {
    return _c('div', {
      key: index,
      staticClass: "cadreCorporate",
      staticStyle: {
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.redirectDetails(entity)
        }
      }
    }, [_c('b-row', [_c('b-col', {
      staticClass: "h4 text-left",
      attrs: {
        "sm": "4"
      }
    }, [_vm._v("\n            SIREN : " + _vm._s(entity.SIRENUnit) + "\n          ")]), _vm._v(" "), _c('b-col', {
      staticClass: "h4 text-left",
      attrs: {
        "sm": "8"
      }
    }, [_vm._v("\n            " + _vm._s(entity.Denomination) + "\n          ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
      staticClass: "h6 text-left",
      attrs: {
        "sm": "4"
      }
    }, [_vm._v("\n            SIRET : " + _vm._s(entity.SIRET) + "\n          ")]), _vm._v(" "), _c('b-col', {
      staticClass: "h6 text-left",
      attrs: {
        "sm": "8"
      }
    }, [_vm._v("\n            " + _vm._s(entity.CustomAddress) + "\n          ")])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
      staticClass: "h6 text-left",
      staticStyle: {
        "margin-bottom": "0"
      }
    }, [_vm._v("\n            Activité principale : " + _vm._s(entity.ActivityLabel) + "\n          ")])], 1)], 1)
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "footerButtons"
  }, [_c('b-row', {
    staticClass: "justify-content-start"
  }, [_c('b-col', {
    attrs: {
      "md": "3",
      "offset-md": "8"
    }
  }, [_c('f7-button', {
    staticClass: "button-action milkyBlockBlack",
    on: {
      "click": _vm.verificationSend
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('verifications.btnSubVerification')) + "\n        ")])], 1)], 1)], 1)], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-72849ed4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72849ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/creationPages/VerificationsCreateTemplate.vue
// module id = 2458
// module chunks = 2